import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

const LanguageSelector = ({ hfContent }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('viyero_language', lng);
  };

  const currentLanguage = i18n.language;
  const enFlag = hfContent?.en_flag || "";
  const trFlag = hfContent?.tr_flag || "";

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => changeLanguage('en')}
        className={`p-1 h-auto hover:bg-gray-100 rounded-md ${
          currentLanguage === 'en' ? 'ring-2 ring-gray-400' : 'opacity-60'
        }`}
        title="English"
      >
        <img src={enFlag} alt="English" className="h-5 w-auto object-contain" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => changeLanguage('tr')}
        className={`p-1 h-auto hover:bg-gray-100 rounded-md ${
          currentLanguage === 'tr' ? 'ring-2 ring-gray-400' : 'opacity-60'
        }`}
        title="Turkce"
      >
        <img src={trFlag} alt="Turkce" className="h-5 w-auto object-contain" />
      </Button>
    </div>
  );
};

export default LanguageSelector;
